export type WorkType = 'movie' | 'tv' | 'variety';

export type Region = 'jp' | 'kr';

export type SubtitleStatus = 'completed' | 'in-progress';

export interface SubtitleVersion {
  id: string;
  language: string;
  team: string;
  format: string;
  publishedAt: string;
  note?: string;
}

export interface Work {
  id: string;
  title: string;
  originalTitle: string;
  type: WorkType;
  region: Region;
  year: number;
  genre: string;
  subtitleStatus: SubtitleStatus;
  tags: string[];
  updatedAt: string;
  popularity: number;
  cover: string;
  description: string;
  synopsis: string;
  subtitleNote: string;
  subtitleVersions: SubtitleVersion[];
}

export const TYPE_LABELS: Record<WorkType, string> = {
  movie: '电影',
  tv: '电视剧',
  variety: '综艺',
};

export const REGION_LABELS: Record<Region, string> = {
  jp: '日本',
  kr: '韩国',
};

export const STATUS_LABELS: Record<SubtitleStatus, string> = {
  completed: '已完成',
  'in-progress': '制作中',
};